import {
  ActivityIcon,
  AlarmClockIcon,
  CheckCheckIcon,
  ClockIcon,
  InboxIcon,
  KanbanIcon,
  ListTodoIcon,
  type LucideIcon,
  SendIcon,
  SettingsIcon,
  SunIcon,
  UserRoundCheckIcon,
} from 'lucide-react'

export type NavPath =
  | '/today'
  | '/board'
  | '/inbox'
  | '/tasks'
  | '/owe'
  | '/waiting'
  | '/outbox'
  | '/snoozed'
  | '/done'
  | '/activity'
  | '/settings'

export type NavItem = {
  to: NavPath
  label: string
  icon: LucideIcon
  /** Two-key shortcut after pressing "g" (e.g. g then i). */
  key: string
  /** Which count from items.counts to show as a badge. */
  count?: 'inbox' | 'outbox'
  /** A count from items.counts that needs attention, shown as an amber dot next to the badge. */
  dot?: 'headsUps'
}

/**
 * The top bar: the day, the week, what came in and what waits to go out. The board shows the
 * lists (tasks, promises, waits, snoozed and this week's done), so they have no place of their
 * own here (decision 92).
 */
export const topNav: NavItem[] = [
  { to: '/today', label: 'Today', icon: SunIcon, key: 'y' },
  { to: '/board', label: 'Board', icon: KanbanIcon, key: 'b' },
  { to: '/inbox', label: 'Inbox', icon: InboxIcon, key: 'i', count: 'inbox' },
  { to: '/outbox', label: 'Outbox', icon: SendIcon, key: 'p', count: 'outbox', dot: 'headsUps' },
]

/** The lists as pages: the command palette and the g-shortcuts reach them. */
export const listNav: NavItem[] = [
  { to: '/tasks', label: 'My tasks', icon: ListTodoIcon, key: 't' },
  { to: '/owe', label: 'I owe', icon: UserRoundCheckIcon, key: 'o' },
  { to: '/waiting', label: 'Waiting on', icon: ClockIcon, key: 'w' },
  { to: '/snoozed', label: 'Snoozed', icon: AlarmClockIcon, key: 'z' },
  { to: '/done', label: 'Done', icon: CheckCheckIcon, key: 'd' },
]

/** In the account menu. */
export const accountNav: NavItem[] = [
  { to: '/activity', label: 'Activity', icon: ActivityIcon, key: 'a' },
  { to: '/settings', label: 'Settings', icon: SettingsIcon, key: 's' },
]

export const allNav = [...topNav, ...listNav, ...accountNav]
